import { render, staticRenderFns } from "./CategoriesSplide.vue?vue&type=template&id=40b8b8f4&"
import script from "./CategoriesSplide.vue?vue&type=script&lang=js&"
export * from "./CategoriesSplide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports